module.exports = __webpack_public_path__ + "static/media/search.c34e05f2.webm";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/search.webm
// module id = 1969
// module chunks = 0